import { isApiError } from '@/api'
import { errorMessage } from '../../api/core'
import { packRefusal, type PackRefusal } from './packWords'

/** A refused pack request in plain words (errorCode → sentence, reasons/problems → lines). */
export function refusalOf(e: unknown): PackRefusal {
  if (!isApiError(e) || e.kind === 'network' || e.kind === 'timeout') return { title: errorMessage(e), lines: [] }
  const body = e.body && typeof e.body === 'object' ? (e.body as Record<string, unknown>) : {}
  return packRefusal(e.code, e.message, body.errors)
}
